import { zodResolver } from '@hookform/resolvers/zod'
import Button from '@repo/ui/button'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  StaffAffectationCancellationReasonEnum,
  staffAffectationCancellationReasonEnumMapping
} from '../../../../lib/types/enums/staff-affectation-cancellation-reason/staff-affectation-cancellation-reason.enum'
import { CancelAffectedStaffInput } from '../../../../lib/types/models/affectedStaff/affected-staff-input'
import { getSelectedEnumOption } from '../../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import Form, { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'

type Props = {
  className?: string
  onConfirm: (value: CancelAffectedStaffInput) => void
  onCancel: () => void
  loading?: boolean
}

const formSchema: ZodType<CancelAffectedStaffInput> = z.object({
  cancelledReason: createEnumSchema({
    enumType: StaffAffectationCancellationReasonEnum,
    fieldName: 'Motif de la désaffectation',
    nullish: true
  })
})

const CancelAffectedStaffForm = ({ className, loading, onConfirm, onCancel }: Props) => {
  const form = useForm<CancelAffectedStaffInput>({
    resolver: zodResolver(formSchema),
    mode: FORM_MODE
  })

  return (
    <Form form={form}>
      <form onSubmit={form.handleSubmit(onConfirm)}>
        <div className="divide-y divide-white-active">
          <div className={className}>
            <FormField
              control={form.control}
              name={'cancelledReason'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledSelectInput
                      {...field}
                      dropDownPosition="above"
                      label={'Motif de la désaffectation'}
                      options={Object.values(StaffAffectationCancellationReasonEnum).map(
                        (reason) => ({
                          label: staffAffectationCancellationReasonEnumMapping[reason],
                          value: reason
                        })
                      )}
                      selectedOption={getSelectedEnumOption(
                        field.value,
                        staffAffectationCancellationReasonEnumMapping
                      )}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="pb-6 px-4">
            <div className="flex w-full gap-3 pt-5 px-10">
              <Button
                variant="ghost"
                label={'Annuler'}
                className="w-full"
                onClick={() => onCancel()}
              />
              <Button
                variant="destructive"
                label={'Désaffecter'}
                className="w-full"
                loading={loading}
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>
    </Form>
  )
}

export default CancelAffectedStaffForm
